module.exports = __webpack_public_path__ + "static/img/品牌展示.ff6c18a4.png";